<template>
  <div class="form__flex form__flex-start">
    <div :class="[!isSplit && 'form__left']">
      <div class="field_criterion">
        <VSelect
          id="currency_id"
          v-model="formData.currency_id"
          name="currency_id"
          :options="currency"
          classes="select-border-bottom mb-40"
          class="input-long"
          :errors="v$.currency_id.$errors"
          :server-errors="serverErrors.value?.currency_id"
          :disabled="isBidder ? !isEdit : false"
          placeholder="Валюта закупки"
          @blur="validateField"
          @input="validateField" />

        <VCheckbox
          v-if="!isBidder"
          id="is_criterion_valute"
          v-model="formData.is_criterion_valute"
          :class-form="['form-checkbox mb-40 small-checkbox']"
          name="is_criterion_valute"
          class-label="label"
          :value="formData.is_criterion_valute">
          <template #default="slotProps">
            <label :for="slotProps.for" :class="slotProps.class"> Критерий </label>
          </template>
        </VCheckbox>
      </div>
      <div class="field_criterion">
        <VSelect
          id="payment_term_id"
          v-model="formData.payment_term_id"
          name="payment_term_id"
          :options="paymentOptions"
          classes="select-border-bottom mb-40"
          class="input-long"
          :disabled="disabledPaymentTerm"
          placeholder="Условия оплаты"
          @blur="validateField"
          @input="validateField" />

        <VCheckbox
          v-if="!isBidder"
          id="is_criterion_payment"
          v-model="formData.is_criterion_payment"
          :class-form="['form-checkbox mb-40 small-checkbox']"
          name="is_criterion_payment"
          class-label="label"
          :value="formData.is_criterion_payment"
          :disabled="formData.is_criterion_deley_max">
          <template #default="slotProps">
            <label :for="slotProps.for" :class="slotProps.class"> Критерий </label>
          </template>
        </VCheckbox>
      </div>
      <template v-if="!isBidder && isDefermentTerm">
        <div class="field_criterion field_criterion-between">
          <VInput
            id="deley_min"
            v-model="formData.deley_min"
            name="deley_min"
            type="number"
            :errors="v$.deley_min.$errors"
            :server-errors="serverErrors.value?.deley_min"
            :disabled="(isBidder ? !isEdit : false) || minCriterionDisabled"
            class-form="form__control-length-350"
            :class-input="['input input-long input-placeholder-black input-border-bottom']"
            placeholder="Минимальное зн отсрочки/дни"
            @blur="validateField"
            @input="validateField" />
          <VInput
            id="deley_max"
            v-model="formData.deley_max"
            name="deley_max"
            type="number"
            :errors="v$.deley_max.$errors"
            :server-errors="serverErrors.value?.deley_max"
            :disabled="disabledDelayMax"
            class="form__control-length-350 mb-40"
            :class-input="['input input-long input-placeholder-black input-border-bottom']"
            :placeholder="isBidder ? 'Значение отсрочки' : 'Максимальное зн отсрочки/дни'"
            @blur="validateField"
            @input="validateField" />
        </div>

        <VCheckbox
          id="is_criterion_deley_max"
          v-model="formData.is_criterion_deley_max"
          class-form="mb-40"
          name="is_criterion_deley_max"
          class-label="label"
          :disabled="disabledCriterionDelay"
          :value="formData.is_criterion_deley_max">
          <template #default="slotProps">
            <label :for="slotProps.for" :class="slotProps.class">
              Максимальное значение отсрочки как критерий
            </label>
          </template>
        </VCheckbox>
      </template>

      <VCheckbox
        v-if="!isBidder"
        id="payment_ability_edit"
        v-model="formData.payment_ability_edit"
        name="payment_ability_edit"
        class-form="form-checkbox mb-40"
        :is-switch="true"
        class-label="bg-white">
        <template #default="slotProps">
          <label :for="slotProps.for" :class="slotProps.class">
            Редактируемые поставщиком условия оплаты
          </label>
        </template>
      </VCheckbox>
    </div>

    <div :class="[!isSplit && 'form__right']">
      <transition name="slide-fade">
        <VInput
          v-if="formData.isNds"
          id="nds_counter"
          v-model="formData.nds_counter"
          name="nds_counter"
          type="number"
          :errors="v$.nds_counter.$errors"
          :server-errors="serverErrors.value?.nds_counter"
          :disabled="isBidder ? !isEdit : false"
          :class-input="['input input-long input-placeholder-black input-border-bottom ']"
          placeholder="Процентная ставка НДС"
          @blur="validateField"
          @input="validateField" />
      </transition>

      <VInput
        v-if="isBidder"
        id="deley_max"
        v-model="formData.deley_max"
        name="deley_max"
        type="number"
        :errors="v$.deley_max.$errors"
        :server-errors="serverErrors.value?.deley_max"
        :disabled="disabledDelayMax || disabledCriterionDelay"
        :class-input="['input input-long input-placeholder-black input-border-bottom']"
        :placeholder="isBidder ? 'Значение отсрочки' : 'Максимальное зн отсрочки'"
        @blur="validateField"
        @input="validateField" />

      <VCheckbox
        v-if="!isBidder"
        id="isNds"
        v-model="formData.isNds"
        name="isNds"
        :server-errors="serverErrors.value?.isNds"
        :is-switch="true"
        class-label="bg-white"
        @input="changeNds">
        <template #default="slotProps">
          <label :for="slotProps.for" :class="slotProps.class"> Включить НДС </label>
        </template>
      </VCheckbox>
    </div>
  </div>
</template>

<script setup>
import { computed, defineProps, inject, onMounted, reactive, watch } from 'vue'
import { useStore } from 'vuex'

import VCheckbox from '@/components/ui/form/Checkbox/VCheckbox'
import VInput from '@/components/ui/form/VInput'
import VSelect from '@/components/ui/form/VSelect'
import { findById } from '@/utils/array'
import { CONDITIONS_PAYMENT, CURRENCY } from '@/utils/manual/manualList'
import { manualMemoization } from '@/utils/memoization/manualMemoization'

const store = useStore()

const props = defineProps({
  isBidder: {
    type: Boolean,
    required: false,
  },
  isEdit: {
    type: Boolean,
    required: false,
  },
  maxCriterionDisabled: {
    type: Boolean,
    required: true,
  },
  minCriterionDisabled: {
    type: Boolean,
    required: true,
  },
  isSplit: {
    type: Boolean,
    required: false,
  },
})

const formData = inject('formData')
const v$ = inject('v$')
const serverErrors = inject('serverErrors')
const validateField = inject('validateField')

const currency = reactive([])
const payment = reactive([])

const paymentOptions = computed(() => {
  let isSMR = false
  let paymentArr = []
  formData.categories.forEach((item) => {
    if (item.is_construction === true) isSMR = true
  })
  if (isSMR && (formData.procedure_type_id === 2 || formData.procedure_type_id === 3))
    paymentArr = payment
  else paymentArr = payment.filter((item) => item.id !== 6)
  return paymentArr
})

onMounted(async () => {
  currency.push(...(await manualMemoization(true, CURRENCY)))
  payment.push(...(await manualMemoization(true, CONDITIONS_PAYMENT)))

  if (formData.currency_id && store.getters['auth/isBidder']) {
    setCurrentCurrency()
  }
})

const changeNds = () => {
  if (formData.isNds) formData.nds_counter = 20
  else formData.nds_counter = 0
}

const disabledDelayMax = computed(() => {
  let isDisabled = false
  if (props.isBidder) {
    isDisabled = !props.isEdit || formData.is_criterion_payment
  }

  return isDisabled || props.maxCriterionDisabled
})
const disabledPaymentTerm = computed(() => {
  let isDisabled = false
  if (props.isBidder) {
    isDisabled = !props.isEdit
  }

  return isDisabled || formData.is_criterion_deley_max
})

if (store.getters['auth/isBidder']) {
  watch(() => formData.currency_id, setCurrentCurrency)
}

function setCurrentCurrency() {
  const currentCurrency = findById(formData.currency_id, currency)
  store.commit('lot/setCurrentCurrency', currentCurrency)
}

function isTermName(terms, termId, nameToCheck) {
  const term = terms.find((t) => t.id === termId)
  return !!term && term.name === nameToCheck
}

const isDefermentTerm = computed(() => {
  const options = paymentOptions.value
  if (options?.length === 0) return false
  return isTermName(options, formData.payment_term_id, 'отсрочка')
})
</script>
